import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';
import { PlantProps } from 'utils/types';

export const fileKey = ['productFinderPlants'];

const useFileProductFinderPlants = () => useQuery({
  queryKey: fileKey,
  queryFn: () => agent.getClient()('file-data/calc?dataType=finder_plants').then(
    (response) => {
      const result: PlantProps[] = [];
      response?.data?.data?.forEach((element: any) => {
        result.push({
          ['Plant ID']: element?.['0'],
          ['Plant Name']: element?.['1'],
          ['Plant']: element?.['2'],
          ['Lattitude']: element?.['3'],
          ['Longitude']: element?.['4'],
          ['Truck Y/N']: element?.['5'],
          ['Train Y/N']: element?.['6'],
          ['Boat Y/N']: element?.['7'],
        });
      });

      return result as PlantProps[];
    },
  ),
});

export default useFileProductFinderPlants;
